import React from 'react';
import './StandaloneSection.css';

export interface StandaloneSectionProps {
  title: string;
  children: React.ReactNode;
  className?: string;
  actions?: React.ReactNode; // Optional actions/controls for the header
  style?: React.CSSProperties; // Optional inline styles for dynamic height control
}

/**
 * StandaloneSection - For standalone sections with content
 * Style matches "TOP MOVERS & LIQUIDITY" from the screenshot:
 * - Purple text title at the top with thinning gradient line extending right
 * - Gradient background content area with rounded corners
 * - Margin/padding around content
 * - Optional actions/controls can be placed in the header
 */
const StandaloneSection: React.FC<StandaloneSectionProps> = ({
  title,
  children,
  className = '',
  actions,
  style,
}) => {
  return (
    <div className={`tt-standalone-section ${className}`} style={style}>
      <div className="tt-standalone-header">
        <h3 className="tt-standalone-title">{title}</h3>
        <div className="tt-standalone-line" />
        {actions && <div className="tt-standalone-actions">{actions}</div>}
      </div>
      <div className="tt-standalone-content">
        {children}
      </div>
    </div>
  );
};

export default StandaloneSection;
